// Theme color constants for the application

export const AI_COLORS = {
  primary: '#7C3AED',      // Main AI color
  primaryDark: '#6D28D9',  // Darker shade for hover states
  primaryLight: 'rgba(124, 58, 237, 0.04)', // Light background for hover
};

// Export individual colors for easier imports
export const AI_PRIMARY = AI_COLORS.primary;
export const AI_PRIMARY_DARK = AI_COLORS.primaryDark;
export const AI_PRIMARY_LIGHT = AI_COLORS.primaryLight;
